var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.5 899.5",
    style: {
      enableBackground: "new 0 0 728.5 899.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.5,297h28.3v530.8c0,39.5,35,71.7,78,71.7h397c43,0,78.1-32.2,78.1-71.7V297h28.3 c32.7,0,59.3-26.6,59.3-59.3v-76.8c0-32.7-26.6-59.3-59.3-59.3H512.6V67.9C512.6,31,485.9,1,453.2,1H275.5 c-32.7,0-59.3,30-59.3,66.9v33.6H59.5c-32.7,0-59.3,26.6-59.3,59.3v76.8C0.2,270.4,26.8,297,59.5,297z M598.2,827.8 c0,16-15.9,29-35.4,29h-397c-19.5,0-35.4-13-35.4-29V298.5h467.7V827.8z M258.8,67.9c0-13.1,7.6-24.3,16.7-24.3h177.8 c9,0,16.7,11.1,16.7,24.3l0,32.2H258.8V67.9z M42.9,160.9c0-9.2,7.5-16.7,16.7-16.7h609.6c9.2,0,16.7,7.5,16.7,16.7v76.8 c0,9.2-7.5,16.7-16.7,16.7H59.5c-9.2,0-16.7-7.5-16.7-16.7V160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,655.8c0,5.7,2.3,11,6.3,15.1c4,4,9.4,6.2,15,6.2c5.7,0,11.1-2.2,15.2-6.3l84.8-85.7l84.7,85.5 c4,4.1,9.4,6.3,15.2,6.3c5.7,0,11-2.2,15-6.2c8.4-8.3,8.4-21.8,0.2-30.2l-85-85.8l84.2-85.1c4-4.1,6.2-9.4,6.2-15.1 c0-5.7-2.3-11-6.3-15.1c-8.4-8.3-21.9-8.2-30.2,0.2l-83.9,84.8l-84-84.9c-4-4.1-9.4-6.3-15.1-6.3c-5.7,0-11.1,2.2-15.1,6.2 c-8.4,8.3-8.4,21.8-0.2,30.2l84.3,85.2l-85.1,86C247,644.7,244.8,650.1,244.8,655.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.76a6bc22.svg";
export { ForwardRef as ReactComponent };